import { toRound } from '../../helpers/Format';
import React from 'react';
export const Checkins = ({ lines }) => (lines.map(line => React.createElement("div", { key: line.id, style: {
        width: '90%',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent: 'flex-start',
    } },
    React.createElement("p", { style: { flex: 1 } }, `${line.quantity}x`),
    React.createElement("p", { style: { flex: 8, } }, line.passengerCategoryName),
    React.createElement("p", { style: { textAlign: 'end', } }, toRound(line.total)))));



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Checkins.tsx
// module id = 514
// module chunks = 0